import { IconButton, Tooltip } from "@mui/material"
import HelpOutlineIcon from "@mui/icons-material/HelpOutlineOutlined"

import { WW_BLUE } from "@/theme/tokens"

import { useTours } from "./TourProvider.jsx"

export default function TourHelpButton({ tourId }) {
  const { tours, startTour } = useTours()
  const tour = tours.find((t) => t.id === tourId)
  if (!tour) return null

  return (
    <Tooltip title={`Show me how: ${tour.title}`}>
      <IconButton
        size="small"
        aria-label={`Start tutorial: ${tour.title}`}
        onClick={() => startTour(tourId)}
        sx={{ color: WW_BLUE }}
      >
        <HelpOutlineIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  )
}
